import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../assets/styles/Main.scss";
import "academicons/css/academicons.min.css";
import { useTranslation } from "react-i18next";

function Main() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className="about-section">
        {/* 🔹 Camadas visuais */}
        <div className="overlay"></div>
        <div className="radial-fade"></div>

        {/* 🔹 Conteúdo principal */}
        <div className="image-wrapper">
          <img
            src="https://avatars.githubusercontent.com/u/55842031"
            alt="Avatar"
          />
        </div>
        <div className="content">
          <div className="social_icons">
            <a
              href="https://github.com/yingyangtongxue"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/danielkf"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="http://lattes.cnpq.br/5712124977837346"
              target="_blank"
              rel="noreferrer"
              aria-label="Currículo Lattes"
            >
              <i className="ai ai-lattes ai-2x"></i>
            </a>
          </div>
          <h1>Daniel N. Monteiro</h1>
          <p>{t("intro")}</p>
        </div>
      </div>
    </div>
  );
}

export default Main;
